export default __webpack_public_path__ + "static/media/proam.a897e67f.png";